"use client";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect } from "react";

export default function AnimatedPopup({
  isOpen,
  onClose,
  children,
  label = "Popup Title",
  className = "max-w-md ",
  showHeader = true,
  rounded = "rounded-[12px] sm:rounded-[20px]",
  padding = "p-6",
  icon = "",
  subLabel = "",
}) {
  // Close popup with ESC key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Background Overlay (Click to Close) */}
          <motion.div
            className="fixed inset-0 bg-black/30 z-40 cursor-pointer"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            onClick={onClose}
          />

          {/* Popup Content */}
          <motion.div
            className={`fixed inset-0 z-50 flex items-center justify-center ${padding}`}
            initial={{ opacity: 0, scale: 0.9, y: 40 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 40 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            {/* Prevent closing when clicking inside */}
            <div
              className={`bg-[#363C55] text-white  overflow-hidden backdrop-blur-[50px] shadow-[0_9px_12px_0_rgba(0,_0,_0,_0.15)]  w-full relative ${className} ${rounded}`}
              px
              onClick={(e) => e.stopPropagation()}
            >
              {/* header part  */}

              {showHeader && (
                <div className="flex items-center justify-between px-5 py-[13px]">
                  <div className="flex items-center gap-2.5">
                    {icon && <img src={icon} alt="" />}
                    <h3>{label}</h3>

                    <p className="text-[#c9c9c9]  font-normal text-[12px]">
                      {subLabel}
                    </p>
                  </div>
                  <button
                    onClick={onClose}
                    className=" text-white transition"
                    aria-label="Close popup"
                  >
                    ✕
                  </button>
                </div>
              )}

              {/* Custom Popup Content */}
              <div className="bg-white  text-[#242424]">{children}</div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
